module.exports = __webpack_public_path__ + "img/calendar2-range-fill.7ef223f8.svg";